import { useState } from "react";
import { useSelector } from "react-redux";
import DeleteModal from "../../../../common/DeleteModal";
import DesignationsService from "../../../../../services/HRM/DesignationsService";

const CardItem = ({
	item,
	setItem,
	index,
	setAddModal,
	setViewModal,
	setShouldUpdate,
}) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	return (
		<tr key={index} className="text-center">
			<td>{item?.title}</td>
			<td>{item?.branch?.names[lang]}</td>
			<td>
				{/* {(isExist("edit_job_title") || isExist("delete_job_title")) && ( */}
				<div className="d-flex gap-12">
					<i
						className="la la-edit text-primary fs-24 cursor-pointer"
						onClick={() => {
							setItem(item);
							setAddModal(true);
						}}></i>
					<i
						className="la la-trash text-danger fs-24 cursor-pointer"
						onClick={() => setDeleteModal(true)}></i>
				</div>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.title}
					deletedItem={item}
					modelService={new DesignationsService()}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};

export default CardItem;
